import React from 'react';
import * as S from './PriceBreakUp.styles';

const PriceBreakUp = ({title, breakup}) => {
  if (!breakup.length) {
    return null;
  }
  return (
    <S.PriceBreakUpMainWrap>
      <S.PriceBreakUpHeader>
        <S.PriceBreakUpHeadText>{title}</S.PriceBreakUpHeadText>
      </S.PriceBreakUpHeader>
      <S.PriceBreakUpInnerWrap>
        {breakup.map(item => <S.PriceBreakUpWrap key={item.id}>
          <S.BreakUpInfoTextWrap>
            <S.PriceBreakUpMainText fontSize={item.fs +'px'} fontWeight={item.fw} textColor={item.cc}>{item.k}</S.PriceBreakUpMainText>
          </S.BreakUpInfoTextWrap>
          <S.BreakUpPriceWrap>
            <S.BreakUpMainPriceText fontSize={item.fs + 'px'} fontWeight={item.fw} textColor={item.cc}>
              {item.s}{item.c}{parseInt(item.v).toLocaleString('en-IN')}
            </S.BreakUpMainPriceText>
          </S.BreakUpPriceWrap>
        </S.PriceBreakUpWrap>)}
      </S.PriceBreakUpInnerWrap>
    </S.PriceBreakUpMainWrap>
  );
}

export default PriceBreakUp;